import React from 'react';
import styles from "../css/Commentator.module.css";
import Button from "components/inputs/Button";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import Swal from "sweetalert2";
import AudioForm from "components/form/AudioForm";

import AudioService from "service/apiConfig/AudioService";
import { useDispatch, useSelector } from "react-redux";
import { audioActions } from "reducers/audio";
import { commonActions } from "../../reducers/common";
import {audioValidation} from "../../service/validation/audioValidation";

const AudioModal = ({ create, subTopicList, setSubTopicList }) => {
    const dispatch = useDispatch();
    const openDetail = useSelector(state => state.audioData.openDetail);
    const audioDetail = useSelector(state => state.audioData.audioDetail);
    const imageFile = useSelector(state => state.audioData.imageFile);
    const imageMapFile = useSelector(state => state.audioData.imageMapFile);
    const audioFile = useSelector(state => state.audioData.audioFile);
    const roomSubTopic = useSelector(state => state.audioData.roomSubTopic);
    const typeSelect = useSelector(state => state.audioData.typeSelect);
    const onSave = () => {
        const formData = new FormData();
        const audioDetailData = {
            "id": audioDetail.id === undefined || null ? null : audioDetail.id,
            "roomSubTopic": roomSubTopic,
            "type": {"id": typeSelect.typeId === 4 ? 1 : typeSelect.typeId},
            "seq": audioDetail.seq === undefined ? null : audioDetail.seq,
            "title": audioDetail.title,
            "script": audioDetail.script,
            "imageAltText": audioDetail.imageAltText,
            "invalid": audioDetail.invalid,
            "imageUrl": create ? null : audioDetail.imageUrl ? audioDetail.imageUrl : null,
            "mapImageUrl": create ? null : audioDetail.imageUrl ? audioDetail.imageUrl : null,
        }
        formData.append('audio', JSON.stringify(audioDetailData));
        formData.append('audioFile', audioFile);
        formData.append('imageFile', imageFile);
        formData.append('mapFile', imageMapFile);

        dispatch(commonActions.trueIsLoading());
        dispatch(audioActions.setOpenModal(false));

        AudioService.create(formData)
            .then(response => {
                dispatch(commonActions.falseIsLoading());
                if (response.data.data === null) {
                    audioValidation(response, create, () => {
                        dispatch(audioActions.setOpenModal(true));
                    });
                } else {
                    Swal.fire({
                        text: `${create? "저장" : "수정"}이 완료되었습니다.`,
                        icon: 'success',
                        confirmButtonText: '확인',
                    }).then(r => {
                        if (r.isConfirmed) {
                            let typeId = typeSelect.typeId;
                            let roomId = typeSelect.roomId;
                            AudioService.getAll(roomId, typeId === 4 ? 1 : typeId)
                                .then(response => {
                                    dispatch(audioActions.setSubTopicList(response.data.data));
                                    setSubTopicList(response.data.data)
                                    handleCloseDetail();
                                })
                                .catch(err => console.log(err));
                        }
                    });
                }
                })
                .catch(err => console.log(err));
    }

    const handleCloseDetail = () => {
        dispatch(audioActions.setOpenModal(false));
        dispatch(audioActions.setCreate(false));
        dispatch(audioActions.setAudioDetail({
            id: null,
            title: "",
            script: "",
            imageAltText: "",
            imageUrl: "",
            mapImageUrl: "",
            audioUrl: "",
            invalid: "false",
            seq: 0,
        }))
        dispatch(audioActions.setImageFile(null));
        dispatch(audioActions.setImageMapFile(null));
        dispatch(audioActions.setAudioFile(null));
        dispatch(audioActions.setPreviewImage(null));
        dispatch(audioActions.setPreviewMapImage(null));
        dispatch(audioActions.setRoomSubTopicId(null));
    }

    return (
        <>
            {openDetail &&
            <Dialog
                className={styles.commModal}
                open={openDetail}
                fullWidth={true}
                maxWidth={"sm"}
                onClose={(_, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDetail();
                    }
                }}>
                <DialogTitle>
                    <div className={`modalHeader`}>
                        <Button style={{ background: "#5a54a1" }} onClick={onSave}>{create ? "저장" : "수정"}</Button>
                        <Button style={{ background: "#fff", border: "1px solid #bbb", color: "#222", padding: "0.5rem" }} onClick={handleCloseDetail}>나가기</Button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <AudioForm create={create} />
                </DialogContent>
            </Dialog>
            }
        </>
    );
};

export default AudioModal;